@if (formGroup) {
  <div class="control-div">
    <mat-button-toggle-group #mediaToggle="matButtonToggleGroup" [value]="selectedMediaType"
      class="control-input select_spacer control-toggle-group" multiple="false"
      (change)="mediaTypeChange(mediaToggle)"
      hideSingleSelectionIndicator>
      <mat-button-toggle value="assets">Assets</mat-button-toggle>
      <mat-button-toggle value="variable">Variable</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <form [formGroup]="formGroup">
    <clickatell-form-validation [controlName]="formControlName"
    [form]="formGroup"></clickatell-form-validation>
    @if (mediaToggle.value == 'assets') {
      <div class="control-div">
        <input #imageRef [formControlName]="formControlName" hidden>
        <select-media [image]="imageRef.value"
          (setImageRef)="setImage($event)" [mediaFilter]="mediaFilter">
        </select-media>
      </div>
    } @else {
      <div class="control-div">
        <div class="control-label-container">
          <label class="control-label"> Media </label>
        </div>
        <input class="control-input select_spacer"
          activeForm [activeForm]="formGroup"
          id="mediaVar"
          [formControlName]="formControlName"
          placeholder="Enter a variable" style="resize: none"/>
        </div>
      }
    </form>
  }



